import { createReducer } from '@reduxjs/toolkit';

import * as digitalActions from './digitalActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: 0,
  type: 'digital',
  isActive: false,

  isDisplayPrice: true,
  layout: 'grid',
  items: [],
};

const digital = createReducer(initialState, (builder) => {
  builder
    .addCase(digitalActions.digitalStore, (state, { payload: data }) => {
      const { blockId, uid, isActive, digital: digitalData } = data;
      const section = digitalData ?? {};

      return {
        ...state,
        error: null,
        requesting: false,
        id: blockId ?? 0,
        uid: uid ?? 0,
        isActive: isActive,
        isDisplayPrice: section.isDisplayPrice ?? true,
        layout: section.layout ?? 'grid',
        items: section.items ?? [],
      };
    })
    .addCase(digitalActions.digitalClear, () => ({ ...initialState }))

    .addCase(digitalActions.digitalUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(digitalActions.digitalUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(digitalActions.digitalUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(digitalActions.digitalUpdateIsDisplayPrice, (state, { payload }) => ({ ...state, isDisplayPrice: payload }))
    .addCase(digitalActions.digitalUpdateLayout, (state, { payload }) => ({ ...state, layout: payload }))
    .addCase(digitalActions.digitalUpdateItems, (state, { payload }) => ({ ...state, items: payload }));
});

export default digital;
